// تفصيلُ الخصومات في كشف الرواتب (components/attendance/payroll-deduction-breakdown.tsx).
const EN_B19: Record<string, string> = {
  "التفصيل": "Breakdown",
  "التفصيل غير متوفر": "Breakdown unavailable",
  "خصم التأخير": "Lateness deduction",
  "دقائق مستبعدة من خصم التأخير": "Minutes excluded from the lateness deduction",
  "خصم الغياب": "Absence deduction",
  "خصم الساعات الناقصة": "Missing-hours deduction",
  "خصم الانصراف المبكر": "Early-leave deduction",
  "فرق التقريب": "Rounding difference",
  "الأساسي ÷ 26 ÷ 8 ÷ 60": "basic ÷ 26 ÷ 8 ÷ 60",
  "الأساسي ÷ 26 ÷ 8": "basic ÷ 26 ÷ 8",
  "الأساسي ÷ 26": "basic ÷ 26",
  "إعداد الشركة": "company setting",
  "الدقائق والساعات بعد السماح والإجازة المطبّقة. المبالغ محسوبة بالسعر غير المقرّب ثم قُرّبت لأقرب فلس.":
    "Minutes and hours are after the applicable grace and leave. Amounts use the unrounded rate, then are rounded to the nearest fils.",
  "صفٌّ احتُسب قبل حفظ التفصيل": "Row computed before the breakdown was stored",
  "مخزنُ التفصيل غيرُ متاح": "Breakdown storage is unavailable",
  "احتُسب الصفّ بعد حفظ التفصيل بنسخةٍ لا تحفظه": "Row recomputed after the breakdown by a version that does not store it",
  "التفصيلُ لا يطابق هويّة الصفّ": "Breakdown does not match the row identity",
  "التفصيلُ لا يطابق فترة الصفّ": "Breakdown does not match the row period",
  "التفصيلُ لا يطابق المبالغ المحفوظة": "Breakdown does not match the stored amounts",
  "نسخةُ تفصيلٍ غيرُ معروفة": "Unknown breakdown version",
  "تفصيلٌ غيرُ صالح": "Invalid breakdown",
};
export default EN_B19;
